/** A player disc: their Steam avatar, or their initial. Mine gets the accent ring. */
export function Avatar({ name, url, me = false, size = 32 }: { name: string; url?: string | null; me?: boolean; size?: number }) {
  const cls = `avatar${me ? " avatar-me" : ""}`;
  const style = { width: size, height: size, fontSize: Math.round(size * 0.42) };
  if (url) return <img className={cls} src={url} alt="" width={size} height={size} style={style} referrerPolicy="no-referrer" />;
  return (
    <span className={cls} style={style} aria-hidden="true">
      {name.trim().charAt(0).toUpperCase() || "?"}
    </span>
  );
}
